import { Component, OnInit } from '@angular/core';
import { DataTableFilterService } from 'ziti-console-lib';

// Beta identities list: renders ziti-console-lib's <lib-identities-list>. Its behavior comes from
// IdentitiesExtensionService, provided app-wide via IDENTITY_EXTENSION_SERVICE.
@Component({
    selector: 'netfoundry-ui-identities-list-extension',
    templateUrl: './identities-list-extension.component.html',
    standalone: false,
})
export class IdentitiesListExtensionComponent implements OnInit {
    constructor(private filterService: DataTableFilterService) {}
    ngOnInit() {
        // Match the rows-per-page control's default of 25 (lib default is 50). DataTableFilterService
        // is a root singleton, so this sets a global default — benign; the legacy page manages its own paging.
        this.filterService.pageSize = 25;
    }
}
